import React from "react"

import QuickSearch_Header from "./components/header/header"
import QuickSearch_SearchResults from "./components/search-results/search-results"
import QuickSearch from "./model/quick-search"


type Props = {
    className?   : string

    onClick      : callback
    onCloseModal : callback
}



// const debug = "QuickSearch_Main"
const debug = false

export default class QuickSearch_Main extends React.Component<Props> {

    public quickSearch : QuickSearch = new QuickSearch()

    constructor(props: Props) {
        super(props)
    }

    componentWillUnmount() {
        this.quickSearch.delayedSearch.cancel()
    }

    // It has to be here in main compoennt to catch all the events
    onKeyDown = (event: React.KeyboardEvent) => {

        // console.log("onPopoverKeyDown", event)

        let newValue;

        switch(event.key) {

            case 'Escape':
                return gd.modal.hide()

            case 'ArrowUp':
                return this.quickSearch.keyboardIterator.moveUp()

            case 'ArrowDown':
                return this.quickSearch.keyboardIterator.moveDown()

            case 'Enter':
                if (!_.isNull(this.quickSearch.keyboardIterator.currentIndex)) {
                    const searchResult = this.quickSearch.results.items[this.quickSearch.keyboardIterator.currentIndex]
                    searchResult.onClick?.()
                }
                return
        }
    }

    render = ()=>  {

        return (
            <div className={Classes("go-to", this.props.className)} onClick={this.props.onClick} onKeyDown={this.onKeyDown}>

                <QuickSearch_Header quickSearch     = {this.quickSearch}
                                    onCloseModal    = {this.props.onCloseModal} />

                <QuickSearch_SearchResults quickSearch={this.quickSearch} skipAutoRegister={false} />

            </div>
        )
    }
}
